var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgUnauthorizedTimesheet = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 60,
    viewBox: "0 0 59 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.5625 33.75V26.25C6.5625 25.7527 6.76004 25.2758 7.11167 24.9242C7.46331 24.5725 7.94022 24.375 8.4375 24.375H49.6875C50.1848 24.375 50.6617 24.5725 51.0133 24.9242C51.365 25.2758 51.5625 25.7527 51.5625 26.25V33.75C51.5625 34.2473 51.365 34.7242 51.0133 35.0758C50.6617 35.4275 50.1848 35.625 49.6875 35.625H8.4375C7.94022 35.625 7.46331 35.4275 7.11167 35.0758C6.76004 34.7242 6.5625 34.2473 6.5625 33.75Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0625 0.9375C13.0078 0.9375 0 13.9453 0 30C0 46.0547 13.0078 59.0625 29.0625 59.0625C45.1172 59.0625 58.125 46.0547 58.125 30C58.125 13.9453 45.1172 0.9375 29.0625 0.9375ZM49.6875 35.625H8.4375C7.94022 35.625 7.46331 35.4275 7.11167 35.0758C6.76004 34.7242 6.5625 34.2473 6.5625 33.75V26.25C6.5625 25.7527 6.76004 25.2758 7.11167 24.9242C7.46331 24.5725 7.94022 24.375 8.4375 24.375H49.6875C50.1848 24.375 50.6617 24.5725 51.0133 24.9242C51.365 25.2758 51.5625 25.7527 51.5625 26.25V33.75C51.5625 34.2473 51.365 34.7242 51.0133 35.0758C50.6617 35.4275 50.1848 35.625 49.6875 35.625Z",
    fill: "url(#paint1_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 29.0625,
    y1: 24.375,
    x2: 29.0625,
    y2: 35.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 29.0625,
    y1: 0.9375,
    x2: 29.0625,
    y2: 59.0625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3DA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.125,
    height: 60,
    fill: "white"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgUnauthorizedTimesheet);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/unauthorized-timesheet.e96e18a7f7376b5ea1bf82924e8bd67d.svg";